(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;
  const isMainPage = path === "/" || path === "";
  const isSpecialPage =
    path.includes('/products/') ||
    path.includes('/collections/') ||
    path.includes('/policies/') ||
    path.includes('/cart') ||
    path.includes('/pages/');

  const stickyHeader = document.querySelector("sticky-header");

  if (isSpecialPage && stickyHeader) {
    // Replace <sticky-header> with <div> and apply fixed black + color-scheme-3
    const headerWrapper = document.createElement("div");
    headerWrapper.className = stickyHeader.className;
    headerWrapper.innerHTML = stickyHeader.innerHTML;
    stickyHeader.replaceWith(headerWrapper);

    headerWrapper.classList.add("scrolled-past-header");
    headerWrapper.classList.remove("color-scheme-5");
    headerWrapper.classList.add("color-scheme");

    const innerHeader = headerWrapper.querySelector(".header");
    if (innerHeader) {
      innerHeader.style.position = "relative";
      innerHeader.style.top = "unset";
    }

    const main = document.querySelector("main, .main-content, .product");
    if (main) {
      main.style.paddingTop = "140px";
    }

  } else if (isMainPage && stickyHeader) {
    // Main page: start with default color-scheme-5 and scroll to 3
    window.addEventListener("scroll", function () {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      if (scrollY > 750) {
        stickyHeader.classList.add("scrolled-past-header");
        stickyHeader.classList.remove("color-scheme-5");
        stickyHeader.classList.add("color-scheme");
      } else {
        stickyHeader.classList.remove("scrolled-past-header");
        stickyHeader.classList.remove("color-scheme");
        stickyHeader.classList.add("color-scheme-5");
      }
    });
  }
});
  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector("sticky-header, .shopify-section-header");
    const logo = document.querySelector(".header__heading-logo.motion-reduce.default-logo");

    if (header && logo) {
      function updateLogo() {
        if (header.classList.contains("scrolled-past-header")) {
          logo.style.filter = "none"; 
        } else {
          logo.style.filter = "brightness(0) invert(1)"; 
        }
      }
      window.addEventListener("scroll", updateLogo);
      updateLogo(); 
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const mobileVideo = document.querySelector('.uploaded-video-mobile');
  if (mobileVideo) {
    mobileVideo.muted = true;
    mobileVideo.playsInline = true;
    mobileVideo.autoplay = true;
    mobileVideo.play().catch(e => {
      console.warn("Mobile video autoplay failed:", e);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
